import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

// import { Provider } from 'react-redux'
// import { store } from './store'

import Amplify from 'aws-amplify';
import awsconfig from './aws-config';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Amplify.configure(awsconfig)
// Amplify.Analytics.autoTrack('session', {
//   enable: true,
//   provider: 'AWSPinpoint'
// })


Bugsnag.start({
  apiKey: 'a6a606a715b1289e11f7025d9fc81758',
  plugins: [new BugsnagPluginReact()]
})
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

ReactDOM.render(
  <ErrorBoundary onError = {(error, componentStack) => {
    // console.log('error')
    // console.log(error)
    // console.log(componentStack)
    // if (error.errors[0].errorMessage.indexOf('Cannot read properties of undefined') !== false) {
    //   window.localStorage.setItem('rtc-lang', 'en-US');
    //   window.location.reload()
    // }
  }}>
    <React.StrictMode>
      {/* <Provider store={store}> */}
        <App />
      {/* </Provider> */}
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// regSW()

// combo de idioma
// https://letsbuildui.dev/articles/building-a-dropdown-menu-component-with-react-hooks